$.fn.extend({
	animateCSS: function (options, callback, context) {
		let animation = options;
		if (typeof options === 'object') {
			animation = options.animation;
		}

		if (typeof callback !== 'function') {
			callback = _.noop;
		}
		callback = _.bind(callback, context ? context : this);

		if (options.css !== undefined) {
			if (options.css.height != null && options.css.height.toLowerCase() === 'auto') {
				//If auto height animation was passed in, we need to get the autoheight and then animate to it
				//Then we set the height back to auto after the animation is done
				let curHeight = this.outerHeight();
				options.css.height = this.css('height', 'auto').outerHeight();
				this.height(curHeight).animate(options.css, {
					complete: _.bind(function () {
						this.css('height', 'auto');
						callback();
					}, this)
				});
			}
			else {
				this.animate(options.css, options.duration ? options.duration : 400, callback);
			}
		}
		else {
			let animationLowered = animation.toLowerCase();
			if (animationLowered === 'slideup' || animationLowered === 'slidedown' || animationLowered === 'fadein' || animationLowered === 'fadeout') {
				if (this.hasClass('hidden')) {
					this.css({
						display: 'none'
					}).removeClass('hidden');
				}
				if (this.hasClass('invisible')) {
					this.css({
						opacity: 0
					}).removeClass('invisible');
				}
				switch (animationLowered) {
					case 'slideup':
						this.slideUp(options.duration ? options.duration : 400, callback);
						break;
					case 'slidedown':
						this.slideDown(options.duration ? options.duration : 400, callback);
						break;
					case 'fadein':
						this.fadeTo(options.duration ? options.duration : 400, 1, callback);
						break;
					case 'fadeout':
						this.fadeTo(options.duration ? options.duration : 400, 0, callback);
						break;
				}
			}
			else {
				let animationEnd = (function (el) {
					let animations = {
						animation: 'animationend',
						OAnimation: 'oAnimationEnd',
						MozAnimation: 'mozAnimationEnd',
						WebkitAnimation: 'webkitAnimationEnd',
					};

					for (let t in animations) {
						if (el.style[t] !== undefined) {
							return animations[t];
						}
					}
				})(document.createElement('div'));

				let wasInvisible = false;
				if (animation.toLowerCase().indexOf('in') !== -1 && this.hasClass('hidden')) {
					this.removeClass('hidden');
				}
				else if (animation.toLowerCase().indexOf('in') !== -1 && this.hasClass('invisible')) {
					this.css('opacity', 0);
					this.removeClass('invisible');
				}
				this.addClass('animated ' + animation).on(animationEnd, function (e) {
					if (e.target === this) {
						$(this).off(animationEnd);
						if (animation.toLowerCase().indexOf('out') !== -1) {
							if (wasInvisible) {
								$(this).addClass('invisible');
							}
							else {
								$(this).addClass('hidden');
							}
						}
						$(this).removeClass('animated ' + animation);
						callback();
					}
				});
			}
		}
		return this;
	},
});